import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteCulturaCadastro } from '../service';
import {
  DELETE_CULTURA_CADASTRO,
  DELETE_CULTURA_CADASTRO_PENDING,
  DELETE_CULTURA_CADASTRO_SUCCESS,
  DELETE_CULTURA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteCulturaCadastro(action) {
  yield put({ type: DELETE_CULTURA_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.CULTURA_EXCLUIR);

  try {
    const a = yield call(deleteCulturaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_CULTURA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CULTURA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a cultura não possuí lançamentos vinculados e tente novamente...');
  }
}

export default function* watchDeleteCulturaCadastro() {
  yield takeLatest(DELETE_CULTURA_CADASTRO, sagaDeleteCulturaCadastro)
}
